import { contentDelete, contentGet, contentPost, contentPut } from '../email-activity/content-api'

// The partner API's organization side (Phase E; plan Task 9): content's
// person-only /api/ddd routes for the organization's own admins. Each
// resolves to the body; a refusal throws the response ({ status, data: {
// code, message } }), so serverMessage(err) shows the server's sentence.

// A member's linked accounts, every status, oldest first: [{ id,
// system_key, external_id, status, member_status, source, api_key: { id,
// name } | null, lms_connection: { id, name } | null, created_at,
// suspended_at, revoked_at, revoke_reason }]. userID is the member page's
// id (the users row). USER read.
export const listLinkedAccounts = userID => contentGet(`user-login/${userID}/linked-accounts`)

// Revoke one (a reason of 1 to 500 characters is required): the link as
// revoked. USER update; a second revoke is a 404.
export const revokeLinkedAccount = (id, reason) => contentPost(`linked-account/${id}/revoke`, { reason: String(reason || '').trim() })

// A group's partner external id: { group_id, system_key, external_id }, both
// null when it has none. GROUP read to read, GROUP update to map or clear.
export const getGroupExternalID = groupID => contentGet(`group/${groupID}/external-id`)
export const setGroupExternalID = (groupID, { systemKey, externalID }) =>
  contentPut(`group/${groupID}/external-id`, { system_key: systemKey, external_id: externalID })
export const clearGroupExternalID = groupID => contentDelete(`group/${groupID}/external-id`)

// The system keys of the organization's live API keys, sorted: the
// suggestions when a group is mapped (a mapping may name another). GROUP read.
export const listPartnerSystemKeys = () => contentGet('partner-system-keys')
